module.exports = __webpack_public_path__ + "static/media/gallery11.d94ca6be.jpeg";